import * as React from 'react'
// components
import AppBar from './AppBar'
import Drawer from './Drawer'
import PageModals from 'containers/PageModals'
import PageLoader from 'components/UI/Loader/PageLoader'
// view components
import { ErrorBoundary } from 'components/ErrorBoundary'
// hooks
import { useRouter } from 'hooks/useRouter'
import { useNetworkStatus } from 'hooks/useNetworkStatus'
// context
import { MainLayoutAPIContext } from 'containers/MainLayout/layers/API'
// types
import { IMainLayoutProps } from 'containers/MainLayout'
// views
import { Backdrop, BurgerMenu, BWrapper, InnerWrapper, Layout, Scrollbar, Wrapper } from './views'

const MainLayout: React.FC<IMainLayoutProps> = ({ label, center, children, CTA, isLoading, disableScroll = false }) => {
  const router = useRouter()
  const onLine = useNetworkStatus()

  const { offset, isDrawerExpanded, toggleDrawer } = React.useContext(MainLayoutAPIContext)

  const ChildrenWrapper = disableScroll ? InnerWrapper : Scrollbar

  return (
    <Layout onLine={onLine}>
      <AppBar label={label} center={center} CTA={CTA} isLoading={isLoading} />
      <Drawer />

      <BWrapper>
        <BurgerMenu htmlColor='white' onClick={toggleDrawer} />
      </BWrapper>

      {isDrawerExpanded && <Backdrop onClick={toggleDrawer} />}

      {isLoading ? (
        <PageLoader isLoading={isLoading} />
      ) : (
        <Wrapper offset={offset}>
          <ChildrenWrapper>
            {/* a broken page keeps the app bar and the menu, so the user can go elsewhere */}
            <ErrorBoundary source='page' resetKey={router.pathname}>
              {children}
            </ErrorBoundary>
          </ChildrenWrapper>
        </Wrapper>
      )}

      <PageModals />
    </Layout>
  )
}

export default MainLayout
